var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.componentClasses,on:{"click":_vm.clicked}})
}
var staticRenderFns = []

export { render, staticRenderFns }